import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./Providers/Auth";
import { GeneralProvider } from "./Providers/General";
import { Toaster } from "./shadcnComponents/ui/toaster";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { NotificationProvider } from "./Providers/Notification";

const helmetContext = {};
ReactDOM.hydrateRoot(
  document.getElementById("root") as HTMLElement,
  <React.StrictMode>
    <HelmetProvider context={helmetContext}>
      <BrowserRouter>
        <GeneralProvider>
          <AuthProvider>
            <NotificationProvider>
              <App />
              <Toaster />
            </NotificationProvider>
          </AuthProvider>
        </GeneralProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
